import "vite/modulepreload-polyfill";
import { onResize } from "@js/utils/event-utils";

/*
 * Global styles load through the separate `css` entry in the base layout,
 * so they are not imported here.
 */

/*
 * Import and initialize the Vue app
 */
import { initializeApp } from "@js/vue/app.js";

// Snapshot the Twig-rendered DOM before the mount replaces it, so an HMR restore
// feeds the compiler the original template rather than Vue's render output
if (import.meta.hot) {
	preserveOriginalContent();
}

// Store the app instance for HMR
let app = initializeApp();

/*
 * Keep a real viewport-height custom property in sync so `--vh`-based
 * units stay correct on mobile browsers where `100vh` is unreliable.
 */
function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setVh();
onResize(setVh);

/*
 * Keep the sticky header's height in a custom property so layouts can
 * offset against it. Look the header up each time, because Vue replaces
 * the Twig-rendered DOM on mount and again on HMR.
 */
function setNavHeight() {
	const header = document.getElementById("site-header");
	if (!header) return;
	document.documentElement.style.setProperty("--nav-height", `${header.getBoundingClientRect().height}px`);
}

setNavHeight();
onResize(setNavHeight);

/*
 * HMR
 * Keep this at the bottom of this file
 */

import {
	preserveOriginalContent,
	restoreOriginalContent,
	onDispose,
	onAccept,
	logHMRUpdate,
} from "@js/hmr.js";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.dispose(() => {
		onDispose(app);
		restoreOriginalContent();
	});

	import.meta.hot.accept(() => {
		onAccept();
	});

	import.meta.hot.on("vite:beforeUpdate", (event) => {
		event.updates.forEach((update) => {
			logHMRUpdate(update.path);
		});
	});
}
